const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** An assignment/task id in a URL, as opposed to a readable course slug. */
export function isUuid(value: string): boolean {
  return UUID_RE.test(value);
}

/**
 * The readable URL segment for a course: "Data Privacy Essentials" → `data-privacy-essentials`.
 * Keeps any script's letters and digits (a Hindi title stays Hindi; the browser percent-encodes
 * it), so a non-Latin title never collapses to an empty slug.
 */
export function courseSlug(title: string): string {
  const slug = title
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^\p{L}\p{N}]+/gu, '-')
    .replace(/^-+|-+$/g, '');
  return slug || 'course';
}

/** `/learning/<slug>` — the learner's course page, resolved to their own assignment by slug. Links
 * shared before the redesign (`/training/<slug>`) redirect here. */
export function coursePath(title: string): string {
  return `/learning/${encodeURIComponent(courseSlug(title))}`;
}
